export const getChartColor = totalPercentage => {
  if (totalPercentage >= 75) {
    return '#28a745';
  }

  if (totalPercentage >= 25) {
    return '#ffc107';
  }

  return '#dc3545';
};
